export default __webpack_public_path__ + "static/media/fi.f2c54392.svg";